import React from 'react';
import AndieGenericToolRender from './AndieGenericToolRender';
import { useTranslation } from 'react-i18next';
import { ActionRenderAi } from '@/ai/types/action-render-ai';
import { InsightsRounded } from '@mui/icons-material';

type ActionResponse = {
    items?: Array<Record<string, unknown>>;
    total?: number | null;
    hasMore?: boolean;
};

export type AndieGetDailyInsightDataProps = ActionRenderAi<ActionResponse>;

const AndieGetDailyInsightData = (props: AndieGetDailyInsightDataProps) => {
    const { t } = useTranslation();
    return (
        <AndieGenericToolRender<ActionResponse>
            title={() => t('andie.tool.get-daily-insight-data.title')}
            icon={<InsightsRounded fontSize="small" />}
            loadingMessages={() => [t('andie.tool.get-daily-insight-data.loading')]}
            completeMessage={({ result }) =>
                t('andie.tool.get-daily-insight-data.complete', {
                    value: Array.isArray(result?.items) ? result.items.length : 0,
                })
            }
            {...props}
        />
    );
};

export default AndieGetDailyInsightData;
